import React, { useState } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import Input from "../../_default/Input";
import "./Plan.scss";
import Food from "./Food";
import Icon from "../../_default/Icon";

export default function Plan({ set, isAdmin, set_idx, removeSet, removeExercise, addFood, onChange, error }) {
  return (
    <Draggable key={set.id} index={set_idx} draggableId={set.id}>
      {(provided, snapshot) => (
        <div className={`c-define-set ${snapshot.isDragging ? "--ondrag" : ""}`} isDragging={snapshot.isDragging} ref={provided.innerRef} {...provided.draggableProps}>
          <div className="c-set-title">
            <span>Plan {set_idx + 1}</span>
            {isAdmin && (
              <div className="c-btn-collection">
                <div className="c-set-trash-icon" onClick={() => removeSet(set_idx)}>
                  <Icon icon="trash" size={16} />
                </div>

                <div className="c-set-move-icon" {...provided.dragHandleProps}>
                  <Icon icon="move" />
                </div>
              </div>
            )}
          </div>

          <Droppable droppableId={set.id} type="child">
            {(provided) => (
              <div className="c-set-mealplans" ref={provided.innerRef} {...provided.droppableProps}>
                {set.food.map((item, idx) => (
                  <Food isAdmin={isAdmin} item={item} idx={idx} removeExercise={(idx) => removeExercise(idx, set_idx)} onChange={(e, type, food_idx) => {onChange(e, type, food_idx, set_idx)}} error={error} />
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </div>
      )}
    </Draggable>
  );
}
